import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const NotificationItem = ({ notification, onDismiss }) => {
  const typeConfig = {
    deadline: {
      icon: 'Clock',
      color: 'warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20',
    },
    status: {
      icon: 'Bell',
      color: 'accent',
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent/20',
    },
    action: {
      icon: 'AlertCircle',
      color: 'destructive',
      bgColor: 'bg-destructive/10',
      borderColor: 'border-destructive/20',
    },
    success: {
      icon: 'CheckCircle',
      color: 'success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20',
    },
  };

  const config = typeConfig?.[notification?.type] || typeConfig?.status;

  return (
    <div className={`${config?.bgColor} border ${config?.borderColor} rounded-lg p-4 transition-smooth`}>
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 mt-0.5">
          <Icon
            name={config?.icon}
            size={20}
            color={`var(--color-${config?.color})`}
          />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <h4 className="text-sm md:text-base font-medium text-foreground font-caption">
              {notification?.title}
            </h4>
            <button
              onClick={() => onDismiss(notification?.id)}
              className="flex-shrink-0 p-1 hover:bg-muted rounded transition-smooth"
              aria-label="Dismiss notification"
            >
              <Icon name="X" size={16} color="var(--color-muted-foreground)" />
            </button>
          </div>

          <p className="text-xs md:text-sm text-muted-foreground font-caption mb-3">
            {notification?.message}
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
            <span className="text-xs text-muted-foreground font-caption">
              {notification?.time}
            </span>

            {notification?.actionLabel && (
              <Button
                variant="ghost"
                size="sm"
                iconName="ArrowRight"
                iconPosition="right"
                className="self-start sm:self-auto"
              >
                {notification?.actionLabel}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationItem;